import React, { useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  WrenchIcon,
  TruckIcon,
  ShoppingCartIcon,
  ChatBubbleOvalLeftIcon,
} from "@heroicons/react/24/outline";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
const NavBarMenuContactUsOurService = ({ role }) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const navigateWithLang = useLanguageNavigate();
  const [openMenu, setOpenMenu] = useState(null);
  const [menuWidths, setMenuWidths] = useState({});
  const menuRef = useRef([]);
  const closeTimeout = useRef(null);
  const direction = useLanguageDirection();

  // console.log(role)
  const menuData = useMemo(
    () => ({
      buyForMe: {
        name: t("buy_for_me"),
        path: `/explain-buy`,
        icon: <ShoppingCartIcon className="w-5 h-5 lg:h-4 lg:w-4" />,
      },
      countShipping: {
        name: t("count_shipping"),
        path: "/shop-and-ship",
        icon: <TruckIcon className="w-5 h-5 lg:h-4 lg:w-4" />,
      },
      ourService: {
        name: t("our_services"),
        path: "/our-services",
        icon: <WrenchIcon className="w-5 h-5 lg:h-4 lg:w-4" />,
      },
      testimonials: {
        name: t("testimonials"),
        path: "/testimonials",
        icon: <ChatBubbleOvalLeftIcon className="w-5 h-5 lg:h-4 lg:w-4" />,
      },
    }),
    [t, role]
  );

  const handleMouseEnter = (menuName) => {
    clearTimeout(closeTimeout.current);
    setOpenMenu(menuName);
  };

  const handleMouseLeave = () => {
    closeTimeout.current = setTimeout(() => {
      setOpenMenu(null);
    }, 200);
  };

  const handleClick = (e, path, key) => {
    e.preventDefault();
    navigateWithLang(path);
  };

  return (
    <div
      className="relative "
      style={{ marginLeft: 0, marginTop: 0 }}
      dir={direction}
    >
      <div className="justify-center gap-4 py-0 lg:py-3 flex lg:flex-row flex-col lg:mt-[5px] mt-5">
        {Object.keys(menuData).map((key, index) => (
          <div
            key={key}
            className="relative group"
            onMouseEnter={() => handleMouseEnter(menuData[key].name)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="flex flex-col ">
              <a
                href={menuData[key].path}
                ref={(el) => (menuRef.current[index] = el)}
                className={`flex lg:gap-1 gap-2 text-white font-medium md:text-[15px] rounded items-center
                ${
                  openMenu === menuData[key].name
                    ? "group-hover:text-custom-yellow duration-300"
                    : "text-custom-yellow"
                }
                `}
                onClick={(e) => handleClick(e, menuData[key].path, key)}
              >
                {menuData[key].icon}
                {menuData[key].name}
              </a>
              <div
                style={{ width: `${menuWidths[menuData[key].name] || 50}px` }}
                className={`h-[4px] mx-auto mt-1 hidden lg:block group-hover:bg-custom-yellow duration-300`}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavBarMenuContactUsOurService;
